import {useCallback, useContext} from 'react'

import Context from '@s-ui/react-context'

export const useTranslateForm = () => {
  const {i18n} = useContext(Context)

  const translateForm = useCallback(
    ({fields}) => {
      for (const field of fields) {
        const {hint, label, help, constraints, datalist} = field
        if (hint) field.hint = i18n.t(hint, 1)
        if (label) field.label = i18n.t(label, 1)
        if (help) field.help = i18n.t(help, 1)
        if (constraints) {
          constraints.forEach(constraint => {
            if (constraint.message) constraint.message = i18n.t(constraint.message, 1)
          })
        }
        if (datalist) {
          datalist.forEach(datalistItem => {
            datalistItem.text = i18n.t(datalistItem.text, 1)
          })
        }
      }
    },
    [i18n]
  )

  return {
    translateForm
  }
}
